import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'

const VasCodeConfigControl: FC = () => {
  const { control } = useFormContext<IKlantGroepModel>()

  return (
    <>
      <div className='row mb-2'>
        <div className='col-5'>
          <label>Begin:</label>
          <Controller
            name='vasCode.config.DeliveryPeriodStartTime'
            control={control}
            defaultValue='06:00'
            render={({ field }) => <input type='time' {...field} />}
          />
        </div>
        <div className='col-5'>
          <label>Eind:</label>
          <Controller
            name='vasCode.config.DeliveryPeriodEndTime'
            control={control}
            defaultValue='09:00'
            render={({ field }) => <input type='time' {...field} />}
          />
        </div>
      </div>

      <div className='row mb-2'>
        <div className='col-5'>
          <label>Voor (minuten):</label>
          <Controller
            name='vasCode.config.MarginInMinutesBefore'
            control={control}
            defaultValue='20'
            render={({ field }) => <input type='number' {...field} />}
          />
        </div>
        <div className='col-5'>
          <label>Na (minuten):</label>
          <Controller
            name='vasCode.config.MarginInMinutesAfter'
            control={control}
            defaultValue='50'
            render={({ field }) => <input type='number' {...field} />}
          />
        </div>
      </div>
    </>
  )
}

export default VasCodeConfigControl
